import React from "react";
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from '@mch-group/uikit-components';

var Separator = function Separator(_ref) {
  var className = _ref.className,
      isRow = _ref.isRow,
      cssClass = _ref.cssClass,
      id = _ref.id,
      only = _ref.only;
  return /*#__PURE__*/React.createElement(Fragment, null, isRow ? /*#__PURE__*/React.createElement(Row, {
    className: className,
    only: only
  }, /*#__PURE__*/React.createElement(Col, {
    className: "separator"
  }, /*#__PURE__*/React.createElement("hr", null))) : /*#__PURE__*/React.createElement(Container, {
    as: "section",
    id: id,
    className: className
  }, /*#__PURE__*/React.createElement(Divider, {
    className: cssClass
  })));
};

Separator.propTypes = {
  className: PropTypes.string,
  isRow: PropTypes.bool,
  hasMarginBottom: PropTypes.bool,
  cssClass: PropTypes.string,
  id: PropTypes.number,
  only: PropTypes.string
};
var StyledComponent = styled(Separator).withConfig({
  displayName: "Separator__StyledComponent",
  componentId: "sc-16oslud-0"
})([".rm-separator{&.ui.divider{margin-top:0;border-top:none;border-bottom:1px solid #dedede;width:100%;}}&.row{padding:0 !important;hr{background:#dedede;height:1px;margin:0;border:none;}}"]);
var Divider = styled.div.withConfig({
  displayName: "Separator__Divider",
  componentId: "sc-16oslud-1"
})(["margin:1rem 0;border-top:1px solid #dedede;width:100%;"]);
export default StyledComponent;